import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons'

const GalleyItem = ({ item }) => {
    if(item.flex !== 2){
        return (
            <div className="gallery__item">
                <div className={ item.flex === 2 ? "img--small" : "img"}>
                    <img src={item.img} alt="img" />
                </div>
                <div className="message-box">
                    <div className="title">{item.speaker.name}</div>
                    <div className="sub-title">{item.message}</div>
                    <div className="share">
                        <button><FontAwesomeIcon icon={faTwitter} /></button>
                        <button><FontAwesomeIcon icon={faLinkedin} /></button>
                    </div>
                </div>
            </div>
        )
    }else{
        return (
            <div className="gallery__item gallery__item--flex2">
                <div className={ item.flex === 2 ? "img--small" : "img"}>
                    <img src={item.img} alt="img" />
                </div>
                <div className="message-box">
                    <div className="title">{item.speaker.name}</div>
                    <div className="sub-title">{item.message}</div>
                    <div className="share">
                        <button><FontAwesomeIcon icon={faTwitter} /></button>
                        <button><FontAwesomeIcon icon={faLinkedin} /></button>
                    </div>
                </div>
            </div>
        )
    }
}

export default GalleyItem